import React from 'react';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import {Button} from '@chekinapp/ui';
import {useDiscardLastPhotoTarget} from './useDiscardLastPhotoTarget';

type DiscardLastPhotoProps = {
  onClose: () => void;
};

function DiscardLastPhoto({onClose}: DiscardLastPhotoProps) {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const {previousPath, target} = useDiscardLastPhotoTarget();

  const handleGoBack = React.useCallback(() => {
    navigate(previousPath, {replace: true});
    onClose();
  }, [navigate, previousPath, onClose]);

  return (
    <div className="flex flex-col gap-5 px-1 text-center">
      <p className="m-0 text-[14px] leading-[21px] text-[var(--chekin-text-secondary)] kiosko:text-kiosko-m">
        {t(`discard_last_photo_text_${target}`)}
      </p>
      <div className="flex flex-col gap-2">
        <Button
          className="w-full kiosko:h-[114px] kiosko:rounded-[56px] kiosko:text-kiosko-m"
          onClick={onClose}
        >
          {t('stay_here')}
        </Button>
        <Button
          variant="ghost"
          className="w-full text-[color:var(--chekin-color-brand-navy)] kiosko:h-[114px] kiosko:rounded-[56px] kiosko:text-kiosko-m"
          onClick={handleGoBack}
        >
          {t(`discard_last_photo_go_${target}`)}
        </Button>
      </div>
    </div>
  );
}

export {DiscardLastPhoto};
